import React from "react";

/**
 * Two-thumb rating range filter (1-10, integer steps).
 * Uses two native sliders overlapped for a lightweight neo-brutalist look.
 */
export default function RatingRangeFilter({ min, max, onChange }) {
    const setMin = (v) => {
        const nv = Math.min(Number(v), max);
        onChange({ min: nv, max });
    };
    const setMax = (v) => {
        const nv = Math.max(Number(v), min);
        onChange({ min, max: nv });
    };

    return (
        <div className="brut-inset bg-white rounded-xl p-4" data-testid="rating-range-filter">
            <div className="flex items-center justify-between mb-2">
                <div className="text-xs font-black uppercase tracking-wider text-[#4A4A4A]">Rating range</div>
                <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full brut-inset bg-[#FFE55C] text-xs font-black">
                    {min} – {max}
                </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
                <label className="text-[10px] font-bold uppercase tracking-wider text-[#4A4A4A]">
                    Min
                    <input
                        type="range"
                        min={1}
                        max={10}
                        step={1}
                        value={min}
                        onChange={(e) => setMin(e.target.value)}
                        className="w-full accent-[#FFB8D1]"
                        data-testid="range-min"
                    />
                </label>
                <label className="text-[10px] font-bold uppercase tracking-wider text-[#4A4A4A]">
                    Max
                    <input
                        type="range"
                        min={1}
                        max={10}
                        step={1}
                        value={max}
                        onChange={(e) => setMax(e.target.value)}
                        className="w-full accent-[#FFE55C]"
                        data-testid="range-max"
                    />
                </label>
            </div>
        </div>
    );
}
